<template>
  <div class="button-bar-new text-center"
       v-show="is_visible === true">

    <div class="color_pallet pa-2" v-if="text_color || background_color">
      <div class="background" v-if="!item.outlined && background_color">
        <v-color-picker
            dark
            flat
            v-model="item.color"
            :hide-canvas="false"
            :hide-inputs="true"
            :hide-mode-switch="true"
            :canvas-height="140"
            :show-swatches="false"
            class="mx-auto"
        ></v-color-picker>
      </div>
      <div class="text" v-if="text_color">
        <v-color-picker
            dark
            flat
            v-model="item.text_color"
            :hide-canvas="false"
            :hide-inputs="true"
            :hide-mode-switch="true"
            :canvas-height="140"
            :show-swatches="false"
            class="mx-auto"
        ></v-color-picker>
      </div>
    </div>
    <div class="config-opts" v-if="config">
      <v-row class=" config-inner">
        <v-col cols="12" xs="6" sm="6" md="6"
               class="pa-0 mh-25">
          <v-checkbox
              class="ma-0 pa-0"
              small
              dark
              v-model="item.outlined"
              label="Outlined"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" xs="6" sm="6" md="6" class="pa-0 mh-25">
          <v-checkbox
              dark
              class="ma-0 pa-0"

              v-model="item.block"
              label="Block"
          ></v-checkbox>
        </v-col>


        <v-col cols="12" xs="6" sm="6" md="6" class="pa-0 mh-25">
          <v-checkbox
              dark
              class="ma-0 pa-0"

              v-model="item.small"
              label="Small"
          ></v-checkbox>


        </v-col>

        <v-col cols="12" xs="6" sm="6" md="6" class="pa-0 mh-25">
          <v-checkbox
              dark
              class="ma-0 pa-0"

              v-model="item.large"
              label="Large"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" xs="6" sm="6" md="6" class="pa-0 mh-25">
          <v-checkbox
              dark
              class="ma-0 pa-0"

              v-model="item.fab"
              label="FAB"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" xs="6" sm="6" md="6" class="pa-0 mh-25">
          <v-checkbox
              dark
              class="ma-0 pa-0"

              v-model="item.text"
              label="Text"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" xs="6" sm="6" md="6" class="pa-0 mh-25">
          <v-checkbox
              dark
              class="ma-0 pa-0"

              v-model="item.rounded"
              label="Round"
          ></v-checkbox>
        </v-col>
        <v-col cols="6" xs="6" sm="6" md="6" class="pa-0 text-center mh-25">
          <v-btn
              color="blue-grey darken-4"
              @click="openIconModal(item)"
          >
            <v-icon class="white--text" v-if="item.icon && item.item !== ''">
              {{ item.icon }}
            </v-icon>
            <span class="pl-2 white--text" v-if="!item.icon || item.item === ''">
                            No Icon
                        </span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="link-opts pa-4" v-if="link_opts">
      <v-row class="pa-2 config-inner">
        <v-col cols="12" xs="12" sm="12" md="12"
               class="pa-0 mh-25">
          <v-text-field
              v-model="item.value"
              :counter="100"
              dark
              label="Value"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 mh-25">
          <v-text-field
              v-model="item.href"
              :counter="100"
              dark
              label="Link"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div class="color-opts " v-if="config_color">
      <v-row class=" pl-6 pt-4 pr-4 config-inner button-inner-config">
        <v-col cols="12" xs="3" sm="3" md="3"
               class="pa-0 mh-25" v-show="!item.outlined">
          <v-btn
              :color="item.color"
              fab
              class="mt-3"
              rounded
              small
              @click="switch_opt('bck_col')"
          >
          </v-btn>
        </v-col>
        <v-col cols="12" xs="9" sm="9" md="9"
               v-show="!item.outlined"
               class="pa-0 mh-25 text-left pt-2 pl-2">
          <v-text-field
              color="white"
              class="white--text"
              v-model="item.color"
              label="Background Color"
          >

          </v-text-field>
        </v-col>
        <v-col cols="12" xs="3" sm="3" md="3"
               class="pa-0 mh-25">
          <v-btn
              class="mt-3"
              fab
              rounded
              small
              :color="item.text_color"
              @click="switch_opt('txt_col')"
          >
          </v-btn>
        </v-col>
        <v-col cols="12" xs="9" sm="9" md="9"
               class="pa-0 mh-25 text-left pt-2 pl-2">
          <v-text-field
              color="white"
              class="white--text"
              v-model="item.text_color"
              label="Text Color"
          >

          </v-text-field>
        </v-col>
      </v-row>
    </div>
    <v-btn-toggle
        dark
    >
      <v-btn color="#263238"
             @click="switch_opt('color')"
             class="white--text">
        <v-icon>
          mdi-palette-swatch
        </v-icon>
      </v-btn>

      <v-btn color="#263238"
             @click="switch_opt('link')"
             class="white--text">
        <v-icon>
          mdi-link
        </v-icon>
      </v-btn>

      <v-btn color="#263238"
             @click="switch_opt('conf')"
             dark>
        <v-icon class="white--text">
          mdi-cogs
        </v-icon>
      </v-btn>

      <v-btn @click="return_data"
             color="#263238" class="white--text">
        <v-icon>
          mdi-close-box
        </v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<style lang="scss">
.button-inner-config {
  .v-input input, .v-label {
    color: white;
  }
}
</style>
<script>
import store from "@/store/";

export default {
  components: {},
  props: {
    is_visible: Boolean,
    item: Object,
    return_data: Function
  },
  data() {
    return {
      icon_select: false,
      config: false,
      link_opts: false,
      config_link: false,
      config_color: false,
      color_pallet: false,
      text_color: false,
      background_color: false,
      button_icon_dialog: false,
      icons: [
        {
          id: ''
        },
        {
          id: 'mdi-facebook'
        },
        {
          id: 'mdi-facebook-box'
        },
        {
          id: 'mdi-twitter'
        },
        {
          id: 'mdi-twitter-box'
        },
        {
          id: 'mdi-twitter-circle'
        },
        {
          id: 'mdi-linkedin'
        },
        {
          id: 'mdi-linkedin-box'
        },
        {
          id: 'mdi-arrow-all'
        },
        {
          id: 'mdi-arrow-bottom-left'
        },
        {
          id: 'mdi-arrow-bottom-left-bold-outline'
        },
        {
          id: 'mdi-arrow-bottom-left-thick'
        },
        {
          id: 'mdi-arrow-bottom-right'
        },
        {
          id: 'mdi-arrow-bottom-right-bold-outline'
        },
        {
          id: 'mdi-arrow-bottom-right-thick'
        },
        {
          id: 'mdi-arrow-collapse'
        },
        {
          id: 'mdi-arrow-down-bold-outline'
        },
        {
          id: 'mdi-arrow-down-box'
        },
        {
          id: 'mdi-arrow-down-circle'
        },
        {
          id: 'mdi-arrow-down-thick'
        },
        {
          id: 'mdi-arrow-left'
        },
        {
          id: 'mdi-arrow-left-bold'
        },
        {
          id: 'mdi-arrow-left-bold-box'
        },
        {
          id: 'mdi-arrow-left-bold-circle'
        },
        {
          id: 'mdi-arrow-left-bold-outline'
        },
        {
          id: 'mdi-arrow-left-thick'
        },
        {
          id: 'mdi-arrow-right'
        },
        {
          id: 'mdi-arrow-right-bold'
        },
        {
          id: 'mdi-arrow-up'
        },
        {
          id: 'mdi-arrow-up-bold'
        },
        {
          id: 'mdi-arrow-up-bold-outline'
        },
        {
          id: 'mdi-arrow-up-thick'
        },
        {
          id: 'mdi-home'
        },
        {
          id: 'mdi-fast-forward'
        },
        {
          id: 'mdi-fast-forward-outline'
        },
        {
          id: 'mdi-send'
        },
        {
          id: 'mdi-cogs'
        },
        {
          id: 'mdi-lock'
        },
        {
          id: 'mdi-feather'
        },
        {
          id: 'mdi-account'
        }
      ],
    }
  },
  methods: {
    openIconModal: (item) => {
      let payload = {
        active: true,
        item: item
      }
      store.dispatch('setIconBlock', payload)
    },
    close_icon_dialog() {
      this.button_icon_dialog = false;
    },
    switch_opt(opt) {
      switch (opt) {
        case 'conf':
          this.text_color = false;
          this.background_color = false;

          this.config = !this.config;
          this.link_opts = false;
          this.config_color = false;
          break;
        case 'link':
          this.text_color = false;
          this.background_color = false;

          this.config_color = false;
          this.config = false;
          this.link_opts = !this.link_opts;
          break;
        case 'color':
          this.text_color = false;
          this.background_color = false;

          this.config = false;
          this.link_opts = false;
          this.config_color = !this.config_color;
          break;
        case 'txt_col':
          this.background_color = false;
          this.text_color = !this.text_color;
          break;
        case 'bck_col':
          this.text_color = false;
          this.background_color = !this.background_color;
          break;
      }
    }
  }

}
</script>


<style lang="scss">
.button-bar-new {
  position: absolute;
  top: -56px;
  left: -40px;
  right: 0;
  margin: auto;
  width: 200px;
  height: 49px;
  background-color: #263238;
  z-index: 2;

  .config-opts {
    width: 220px;
    height: 160px;
    position: absolute;
    top: -160px;
    left: -10px;
    padding: 10px !important;
    background-color: #263238;

    .config-inner {
      height: 160px;
      overflow: hidden;
      padding: 10px;

      .mh-25 {
        max-height: 25px !important;
      }
    }
  }

  .color_pallet {
    position: absolute;
    width: 200px;
    height: 208px;
    right: -200px;
    top: -160px;
    background-color: #263238;
  }

  .link-opts {
    width: 200px;
    height: 160px;
    position: absolute;
    top: -160px;
    background-color: #263238;

    .config-inner {
      height: 160px;
      overflow: hidden;

      .mh-25 {
        max-height: 25px !important;
      }
    }
  }

  .color-opts {
    width: 200px;
    height: 160px;
    position: absolute;
    top: -160px;
    background-color: #263238;

    .config-inner {
      height: 160px;
      overflow: hidden;

      .mh-25 {
        max-height: 25px !important;
      }
    }
  }
}
</style>
